import styled from 'styled-components';
import closeCircle from '../../assets/svg/close-circle.svg';

export const Box = styled.div`
  background-color: ${p => p.theme.rgba('grayLight', 0.2)};
  border: 1px solid ${p => p.theme.color.grayLight};
  border-radius: 3px;
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 20px 0;
  padding: ${p => p.theme.base.spacing.huge} 40px;
  width: 100%;

  @media (${p => p.theme.mq.mobile}) {
    padding: ${p => p.theme.base.spacing.huge} 18px;
  }
`;

export const Header = styled.div`
  align-items: center;
  display: flex;

  & svg {
    height: 48px;
    margin: 0 20px 0 0;
    width: 48px;

    path {
      fill: ${p => p.theme.color.teal};
    }
  }
`;

export const CloseIcon = styled.button`
  border: none;
  cursor: pointer;
  position: absolute;
  top: 15px;
  right: 15px;
  height: 30px;
  width: 30px;
  background-position: center;
  background-size: contain;
  background-image: url(${closeCircle});
`;

export const Content = styled.div``;



// WEBPACK FOOTER //
// ./src/components/RulesInfo/styles.js